import React from 'react';

const Login = () => {
    return (
        <div style={{ height: '100vh' }}>
            <h2>Developer is Constructing login Page.</h2>
        </div>
    );
};

export default Login;